var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburgerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 9C23.75 9.19891 23.671 9.38968 23.5303 9.53033C23.3897 9.67098 23.1989 9.75 23 9.75H1C0.801088 9.75 0.610322 9.67098 0.46967 9.53033C0.329018 9.38968 0.25 9.19891 0.25 9C0.25 8.80109 0.329018 8.61032 0.46967 8.46967C0.610322 8.32902 0.801088 8.25 1 8.25H23C23.1989 8.25 23.3897 8.32902 23.5303 8.46967C23.671 8.61032 23.75 8.80109 23.75 9ZM1 1.75H23C23.1989 1.75 23.3897 1.67098 23.5303 1.53033C23.671 1.38968 23.75 1.19891 23.75 1C23.75 0.801088 23.671 0.610322 23.5303 0.46967C23.3897 0.329018 23.1989 0.25 23 0.25H1C0.801088 0.25 0.610322 0.329018 0.46967 0.46967C0.329018 0.610322 0.25 0.801088 0.25 1C0.25 1.19891 0.329018 1.38968 0.46967 1.53033C0.610322 1.67098 0.801088 1.75 1 1.75ZM23 16.25H1C0.801088 16.25 0.610322 16.329 0.46967 16.4697C0.329018 16.6103 0.25 16.8011 0.25 17C0.25 17.1989 0.329018 17.3897 0.46967 17.5303C0.610322 17.671 0.801088 17.75 1 17.75H23C23.1989 17.75 23.3897 17.671 23.5303 17.5303C23.671 17.3897 23.75 17.1989 23.75 17C23.75 16.8011 23.671 16.6103 23.5303 16.4697C23.3897 16.329 23.1989 16.25 23 16.25Z",
    fill: "#F1EFE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerIcon);
export default __webpack_public_path__ + "static/media/HamburgerIcon.15dae642727c8706fcf5faadea2ee34f.svg";
export { ForwardRef as ReactComponent };